export default interface DigitalDocumentQueueSenderLoanAgreementFormModel {
  lockerNumber: string; //obsolete
  bikeEquipmentItems: LoanAgreementEquipmentItemTypeEnum[];
  remarksComments: string;
  drivingLicenseId: string;
  drivingLicenceDate: string;
  depositAmount: number;
  lessorPhoneNumber: string;
  batteryCapacity: number | null;
}
export enum LoanAgreementEquipmentItemTypeEnum {
  FenderPresence = 1,
  Flashlights = 2,
  FoldingLock = 3,
  WaterProofPhoneBag = 4,
  PhoneHolder = 5,
  ChargedBattery = 6
}


